import {madnes_audio_loop, madnes_audio_play, madnes_audio_stop} from "../framework/src/engine/madnes/madnes_audio";
import {
    madnes_get_scale_x, madnes_get_scale_y,
    madnes_get_visible,
    madnes_set_alpha,
    madnes_set_pos,
    madnes_set_pos_x,
    madnes_set_texture,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_add_to_render,
    madnes_alpha_to,
    madnes_move_to,
    madnes_rem_from_render, madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {he, mega_win, super_win, wallet, wi} from "../framework/src/engine/madnes/madnes_variables";
import {bet, madnes_money_to_coin} from "../framework/src/engine/madnes/madnes";
import {madnes_show_money, madnes_start_coin, madnes_stop_coin} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {AnimTween} from "./rof_extanims";

function show_win_type(type)
{
    madnes_set_visible("text_wintype", true);
    madnes_set_texture('text_wintype', 'text_' + type);
}

var money_add_big_win_anim_step = 0;
export function set_money_add_big_win_anim_step(val) {
    money_add_big_win_anim_step = val;
}


var money_add_big_win_add_to_render;
var money_add_big_win_callback = function() {};
export function set_money_add_big_win_callback(func) {
    money_add_big_win_callback = func;
}


export function money_add_big_win_anim(max, from_freespin)
{
    switch(money_add_big_win_anim_step)
    {
        case 0:

            setTimeout(function() {
                madnes_audio_play("YOU_WON");
            }, 160);

            if(from_freespin)
            {
                show_win_type('bonuswin');
            }
            else
            {
                show_win_type('bigwin');
            }

            show_bigwin_desk();

            money_add_big_win_anim_step = 1;
            money_add_big_win_anim(max, from_freespin);
            break;
        case 1:
            money_add_big_win_add_pos = 0;
            money_add_big_win_add_max = max;
            money_add_big_win_add_step = -1;

            money_add_big_win_add_to_render = money_add_big_win_add.bind(this, from_freespin);
            madnes_add_to_render(money_add_big_win_add_to_render);
            break;
        case 2:


            money_add_big_win_anim_step = 3;

            windesk_hide();

            money_add_big_win_anim(max, from_freespin);

            break;
        case 3:

            money_add_big_win_anim_step = 0;

            money_add_big_win_callback();

            break;
    }
}

var money_add_big_win_add_pos = 0;
var money_add_big_win_add_max = 0;
var money_add_big_win_add_step = -1;
function money_add_big_win_add(from_freespin)
{
    /*var add = Math.floor(( (bet * big_win) / 100 ) * (Math.random() * 4));

    if(win_type == "FS_WIN_2")
    {
        add = Math.floor(( (bet * mega_win) / 100 ) * (Math.random() * 4));
    }
    if(win_type == "FS_WIN_3")
    {
        add = Math.floor(( win / 180 ) * (Math.random() * 4));
    }*/

    var tmp_add = Math.round( money_add_big_win_add_max * 0.5 * ( Math.random() / 100 ) );
    if(tmp_add < 1)
    {
        tmp_add = 1;
    }
    money_add_big_win_add_pos = money_add_big_win_add_pos * 1 + tmp_add;

    if(money_add_big_win_add_step == -1) {
        madnes_audio_loop('remittance_A');
        money_add_big_win_add_step = 0;
    }

    if(money_add_big_win_add_step == 0 && money_add_big_win_add_pos > bet * mega_win && !from_freespin)
    {
        //money_add_big_win_add_pos = madnes_get_money_bet(bet) * mega_win;
        money_add_big_win_add_step = 1;

        show_win_type("megawin");
    }
    else if(money_add_big_win_add_step == 1 && money_add_big_win_add_pos > bet * super_win)
    {
        //money_add_big_win_add_pos = madnes_get_money_bet(bet) * super_win;
        money_add_big_win_add_step = 2;

        show_win_type("supermegawin");

    }

    if(money_add_big_win_add_pos > money_add_big_win_add_max)
    {
        madnes_stop_coin();

        madnes_audio_stop('remittance_A');
        madnes_audio_play("remittance_B");

        money_add_big_win_add_pos = money_add_big_win_add_max;

        madnes_rem_from_render(money_add_big_win_add_to_render);
        money_add_big_win_anim_step = 2;

        setTimeout(money_add_big_win_anim.bind(this, money_add_big_win_add_max, from_freespin), 3000);
    }

    windesk_setsum(money_add_big_win_add_pos);
}

function windesk_show()
{
    madnes_start_coin();
}

var anim_big_win_fires = {
    "fire_1": null,
    "fire_2": null
};

var anim_bigwin = {
    "bg_shine": 0,
    "frame_shine": 0
};

function show_bigwin_desk()
{
    madnes_set_pos("bigwin_bg_group", wi / 2, he / 2);
    madnes_set_visible("bigwin_bg_group", true);

    madnes_set_pos("bigwin_frame_group", wi / 2, he / 2);
    madnes_set_visible("bigwin_frame_group", true);

    anim_big_win_fires["fire_1"] = new AnimTween("bigwin_flames_1");
    anim_big_win_fires["fire_1"].to({ x: -40 }, 700, 0, -1, true);

    anim_big_win_fires["fire_2"] = new AnimTween("bigwin_flames_2");
    anim_big_win_fires["fire_2"].to({ x: 40 }, 700, 0, -1, true);

    /*anim_bigwin["bg_shine"] = new AnimTween("bigwin_shine");
    anim_bigwin["bg_shine"].to({ x: 500 }, 990, Easing.Linear, 3000, -1, 0);
    anim_bigwin["bg_shine"].run();*/

    move_to("bigwin_shine", 1, 1600);
    frame_shine_alpha_anim(1, 100);
}

function hide_bigwin_desk() {

    for(var key in anim_big_win_fires) {
        anim_big_win_fires[key].stop();
        anim_big_win_fires[key] = null;
    }

    for(var i in anim_bigwin) {
        clearTimeout(anim_bigwin[i]);
    }

    madnes_set_pos("bigwin_bg_group", -9999, -9999);
    madnes_set_visible("bigwin_bg_group", false);

    madnes_set_pos("bigwin_frame_group", -9999, -999);
    madnes_set_visible("bigwin_frame_group", false);
}

function move_to(name, dir, delay)
{
    anim_bigwin["bg_shine"] = setTimeout(function () {
        madnes_set_pos_x(name, -500);

        madnes_move_to(name, 500 * dir, null, 900, move_to.bind(this, name, dir, delay));
    }, delay);

}

function frame_shine_alpha_anim(dir, delay)
{
    anim_bigwin["frame_shine"] = setTimeout(function () {
        var tmpdir;

        if(dir == 0) {
            tmpdir = 1;
        } else {
            tmpdir = 0;
        }

        madnes_set_alpha("bigwin_frame_shine", tmpdir);
        madnes_alpha_to("bigwin_frame_shine", dir, 500, frame_shine_alpha_anim.bind(this, tmpdir, delay));
    }, delay);
}

function windesk_setsum(sum)
{
    madnes_set_visible('windesk_sum', true);
    madnes_set_text('windesk_sum', (sum | 0));
}

function windesk_hide()
{
    if(madnes_get_visible("windesk_sum")) {

        madnes_set_visible('windesk_sum', false);
        hide_bigwin_desk();
    }
}

var freespin_state = new Array();
var pk_lock_1 = 1;

var win_sum_groups = new Array();
var win_sum_buffer = new Array();
var win_sum_buffer_pos = 0;

//var anim_bet_indicators_locked = false;

export function anim_bet_indicators()
{
    //if(anim_bet_indicators_locked) {
    //	return;
    //}

    //anim_bet_indicators_locked = true;

    let bets = wallet.getCreditBets();
    let valueIndex = bets.indexOf(bet);

    var coef = 0;
    if(valueIndex > 0) {
        coef = Math.round((valueIndex + 1) / (bets.length / 100)) / 100;
    }

    madnes_scale_to('left_bet_indicator', coef, null, 160, function() {
        //setTimeout(function() {
        //anim_bet_indicators_locked = false;
        //}, 100);
    });
    madnes_scale_to('right_bet_indicator', coef, null, 160);
};

export function madnes_fade_out(name, duration, delay) {
    if(delay == 'undefined' || !delay) {
        delay = 0;
    }

    setTimeout(madnes_alpha_to.bind(this, name, 0, duration), delay);
}

export function madnes_fade_in(name, duration, delay) {
    if(delay == 'undefined' || !delay) {
        delay = 0;
    }

    setTimeout(madnes_alpha_to.bind(this, name, 1, duration), delay);
}

export function madnes_anim_pulse(name, xScale, yScale, duration, delay) {

    var origScaleX = madnes_get_scale_x(name);
    var origScaleY = madnes_get_scale_y(name);

    setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration), delay);
    setTimeout(madnes_scale_to.bind(this, name, origScaleX, origScaleY, duration), duration + delay);
}

export function madnes_anim_scale(name, xScale, yScale, duration, delay, callback)
{
    setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration, callback), delay);
}

export function anims_money_add_win_anim(won)
{
    return new Promise(function (res) {

        madnes_show_money(madnes_money_to_coin(won), res);

        //console.log("anim start");

        //setTimeout(function() {
        //	console.log("anim stop");
        //res();
        //}, 1200);

    });
}